// extracted by mini-css-extract-plugin
export var attachmentContainer = "_jd-0";
export var fileList = "_jd-2";
export var removeFileButton = "_jd-1";